<template>
    <v-btn v-if="!isGuest"
           ref="download-premiere-extension-button"
           :disabled="isDisabled"
           @click="onClick"
           v-tippy="{placement: 'left'}"
           content="Download Premiere Pro Extension"
    >
        <img src="/assets/icons/pr-icon.png" />
    </v-btn>
</template>

<script>
import CanMixin from "@/mixins/CanMixin";
import FilenameMixin from "@/mixins/Filename";
import { mapGetters, mapState } from "vuex";

export default {
    mixins: [CanMixin, FilenameMixin],
    computed: {
        ...mapGetters('User', ['isGuest']),
        isDisabled() {
            return !this.canDonwloadPremiereExtension
        }
    },
    mounted() {
        this.$root.$refs.downloadPremiereExtensionButton = this.$refs['download-premiere-extension-button'];
    },
    methods: {
        onClick() {
            if (this.isDisabled) return;

            this.$store.dispatch('UI/setRightColumn', 'download-premiere-extension')
        }
    }
}
</script>

<style lang="scss" scoped>
.v-btn--disabled {
    img {
        opacity: 0.4;
    }
}

img {
    width: 20px;
}
</style>